import type { CanvasContext } from '@studio/design-system/canvas';
import { omit } from 'lodash-es';
import type { ReactElement } from 'react';
import { useRef } from 'react';
import { twMerge } from 'cn';
import { Cursor } from '../cursor/index.js';
import type { HandlerProps } from '../types.js';
import { useWiring } from './wiring.js';

/** `Tool.FastFrame` `<Handler>` component. */
export const Handler = (props: HandlerProps): ReactElement => {
  const canvasRef = useRef<CanvasContext>(null);
  const wiring = useWiring(props.deviceId, canvasRef);

  const color = wiring.useCine ? 'stroke-warning' : 'stroke-success';

  return (
    <Cursor
      className={twMerge(color, props.className)}
      initialPosition={wiring.initialPosition}
      key={`cursor-${props.deviceId}-${color}`}
      onDrawCursor={wiring.handleDrawCursor}
      onMouseDown={wiring.handleDragStart}
      onMouseMove={wiring.handleDrag}
      onMouseUp={wiring.handleDragEnd}
      onPointerLeave={wiring.handlePointerLeave}
      onWheel={wiring.handleWheelEvent}
      ref={canvasRef}
      {...omit(props, 'deviceId', 'className')}
    />
  );
};
